/** Minimal client for POST /api/v1/media (raw body, metadata in the query) —
 *  used by template sample images and broadcast header images. The inbox has its
 *  own XHR variant with progress reporting; this one is fetch-based and silent. */
export interface UploadedMediaRef {
  id: number;
  kind: string;
  mime: string;
  filename: string | null;
  size: number;
}

export async function uploadMediaFile(businessId: string, file: File): Promise<UploadedMediaRef> {
  const qs = new URLSearchParams({
    business: businessId,
    mime: file.type || "application/octet-stream",
    filename: file.name,
  });
  const res = await fetch(`/api/v1/media?${qs}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/octet-stream" },
    body: file,
  });
  if (!res.ok) {
    let msg = "Upload failed";
    try {
      msg = ((await res.json()) as { error?: { message?: string } }).error?.message ?? msg;
    } catch {
      /* keep default */
    }
    throw new Error(msg);
  }
  return (await res.json()) as UploadedMediaRef;
}
